import { render, staticRenderFns } from "./LoyaltyPrice.vue?vue&type=template&id=3f6adbf6"
import script from "./LoyaltyPrice.vue?vue&type=script&lang=js"
export * from "./LoyaltyPrice.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyPrice.vue?vue&type=style&index=0&id=3f6adbf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports